import { useMutation } from "@apollo/client";
import { CheckIcon } from "@heroicons/react/solid";
import { MouseEventHandler } from "react";

import Button from "@components/button/button";
import { ButtonSize, buttonTheme } from "@components/button/button-constants";
import { getTopicflowIcon } from "@components/topicflow-icon/topicflow-icon-helpers";
import { topicState } from "@helpers/constants";
import { classNames } from "@helpers/css";
import { showConfetti } from "@helpers/helpers";

import toggleTopicStateMutation from "./graphql/toggle-topic-state-mutation";

const TopicCTA = ({
  topic,
  onlyIcon = false,
  isStatic = false,
}: {
  topic: any;
  onlyIcon?: boolean;
  isStatic?: boolean;
}) => {
  const [toggleState] = useMutation(toggleTopicStateMutation);

  const handleClickToggle: MouseEventHandler<HTMLButtonElement> = (e) => {
    e.preventDefault();
    if (isStatic) return;
    const newState =
      topic.state === topicState.closed ? topicState.open : topicState.closed;
    toggleState({
      variables: {
        topicId: topic.id,
        state: newState,
      },
      optimisticResponse: {
        createOrUpdateTopic: {
          topic: {
            ...topic,
            state: newState,
          },
        },
      },
    });
  };

  const isDiscussed = topic.state === topicState.closed;

  if (isStatic) return null;
  return (
    <Button
      size={ButtonSize.medium}
      theme={buttonTheme.text}
      disabled={isStatic}
      onClick={(e) => {
        if (!isDiscussed) {
          showConfetti({
            confettiNumber: 40,
            confettiRadius: 4,
            confettiColors: ["#10b981", "#34d399", "#6ee7b7", "#a7f3d0"],
          });
        }
        handleClickToggle(e);
      }}
      className={classNames(
        isDiscussed && "border-transparent bg-emerald-50 text-emerald-600",
        isDiscussed && !isStatic && "hover:bg-emerald-100",
        !isDiscussed && "invisible",
        !isDiscussed && !isStatic && "group-hover/topic:visible",
      )}
      icon={onlyIcon ? getTopicflowIcon("check") : undefined}
      children={
        onlyIcon ? undefined : (
          <>
            <CheckIcon className="h-4 w-4 shrink-0" />
            Discussed
          </>
        )
      }
    />
  );
};

export default TopicCTA;
